import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import gymDataReducer from "./reducers/gymDataSlice";
import trainersDataReducer from "./reducers/trainerDataSlice";
import assigneeDataReducer from "./reducers/assigneeDataSlice";
import { settlementFormReducer } from "./reducers/settlementFormSlice";
import apiReducer from "./reducers/apiSlice";
import { clickedRowReducer } from "./reducers/settlementFormSlice";
import filtersReducer from "./reducers/filtersSlice";
import postApiReducer from "./reducers/postApiSlice";
import putApiReducer from "./reducers/putApiSlice";
import deleteApiReducer from "./reducers/deleteApiSlice";
import workoutReducer from "./workout-reducers/workoutApis";
import websiteReducer from "./website-reducers/websiteSlice";
import hygieneReducer from "./hygiene-reducers/hygieneSlice";
import tabsReducer from "./reducers/tabsSlice";
import authReducer from "./reducers/authSlice";
import sidebarReducer from "./reducers/sidebar";
import dropdownApiReducer from "./reducers/dropdownApiSlice";
import incentivesReducer from "./incentives-reducers/incentivesSlice";
import commonApiReducer from "./reducers/commonApiSlice";
import notificationReducer from "./reducers/notificationSlice";
import plansReducer from "./plans-reducers/plansSlice";
import ptPlansReducer from "./plans-reducers/ptPlansSlice";
import prospectReducer from "./prospect-reducers/prospectSlice";
import paymentReducer from "./payment-reducerss/paymentSlice";
import blogReducer from "./ad-blog-reducers/blogSlice";
import featureReducer from "./dashboard-features/featuresSlice";
import transferReducer from "./transfer-reducers/transferSlice";
import payroleReducer from "./payrole-reducers/payroleSlice";
import ticketSystemReducer from "./reducers/ticketSystemSlice";
import liveReducer from "./live-reducers/liveSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorageEngine from "redux-persist/lib/storage/session";
import { isSupportMode, isSupportHandoff } from "../utils/supportMode";

// A WTF Go support tab (see utils/supportMode.js) keeps its login in sessionStorage —
// per tab — so it can never overwrite the admin's own login in localStorage. Decided
// once, at boot: a support tab, or a tab landing on the hand-off link (which then logs
// in and moves to /app without reloading).
const persistConfig = {
  key: "authUser",
  storage: isSupportMode() || isSupportHandoff() ? sessionStorageEngine : storage,
};

const persistedReducer = persistReducer(persistConfig, authReducer);

// The full reducer map. Exported so tests can build a store with the COMPLETE
// slice set (a hand-picked subset makes deep component trees crash on a missing
// slice, e.g. useSelector(s => s.features) → undefined). App store below uses the
// SAME object, so exporting it changes nothing at runtime. Note: `auth` here is the
// persisted reducer; tests that don't want persistence can override just that key.
export const appReducers = {
  user: userReducer,
  gymData: gymDataReducer,
  trainersData: trainersDataReducer,
  assigneeData: assigneeDataReducer,
  settlementForm: settlementFormReducer,
  api: apiReducer,
  clickedRow: clickedRowReducer,
  filters: filtersReducer,
  postApi: postApiReducer,
  putApi: putApiReducer,
  delApi: deleteApiReducer,
  workoutApi: workoutReducer,
  webApi: websiteReducer,
  hygiene: hygieneReducer,
  tabs: tabsReducer,
  auth: persistedReducer,
  sidebar: sidebarReducer,
  dropdown: dropdownApiReducer,
  common: commonApiReducer,
  incentives: incentivesReducer,
  notification: notificationReducer,
  plans: plansReducer,
  ptPlans: ptPlansReducer,
  prospects: prospectReducer,
  payment: paymentReducer,
  blog: blogReducer,
  features: featureReducer,
  transfer: transferReducer,
  payrole: payroleReducer,
  ticketSystem: ticketSystemReducer,
  live: liveReducer,
};

export const store = configureStore({
  reducer: appReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
